import React from 'react'
import { Helmet } from 'react-helmet'

export default function Helmet_tags({name,description,keywords}) {
  return (
    
<Helmet>
        {/* <!-- HTML Meta Tags --> */}
 
        <title>{name} | Halo Digital</title>
       
        <meta
          name="description"
          content={description}
        />


    <meta name="keywords" content={keywords} />
 
    {/* <link rel="canonical" href="" /> */}

        {/* <!-- Google / Search Engine Tags --> */}
        <meta itemprop="name" content={`${name} | Resonance worldwide`} />
       
    <meta
    itemprop="description"
    content={description}
  />
       
        
    

        {/* <!-- Facebook Meta Tags --> */}
        {/* <meta property="og:url" content="" /> */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={`${name} | Resonance worldwide`} />
      
    <meta
          property="og:description"
          content={description}
        />
        
      
      

      
       
      </Helmet>

  )
}
